import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "up-GD9uz",
  "use": "up-GD9uz-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"up-GD9uz\"><path d=\"M6.979 0L0 7.049l1.639 1.628 4.202-4.173V14h2.318V4.504l4.202 4.173L14 7.049z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol